import { InferType, number, object, string } from "yup";
import { SiteSchema } from "./Site";
import moment from "moment-timezone";

export enum Stats {
    DA = "DA",
    TF = "TF",
    CF = "CF",
    RD = "RD",
    TRAFFIC = "TRAFFIC",
    KW = "KW",
    GOOGLE_RESULT = "GOOGLE_RESULT",
}
export type TStats = keyof typeof Stats;

export const StatsSiteschema = object({
    id: number().required(),
    site: SiteSchema,
    statName: string<TStats>().required("error.order.contentType.required").default("DA"),
    statValue: number().required(),
    date: string()
        .required()
        .transform((v1) => {
            if (!v1) return "";
            return moment(v1).tz("Europe/Paris").format("DD/MM/YY");
        }),
});

export type StatsSites = InferType<typeof StatsSiteschema>;
